import React from 'react';
import { Link } from 'react-router-dom';  

/** Bootstrap Components */
import { Card,Container,Row,Col,Form } from 'react-bootstrap';  

/** React Icons */
import { FaArrowCircleRight,FaExclamationTriangle } from "react-icons/fa";

/** Custom CSS */
import '../css/styles.css';  

/** Custom Components */
import NavbarComponent from '../navbar';
import FooterComponent from '../footer';

import { MENU_HEADER_URL } from '../utils/constants';


class MainComponent extends React.Component {  
	constructor(props) {
		super(props);
		this.state = {
			error: null,
			isLoaded: false,
			items: [],
			finYearArr : [],
			currentFinYear: ''
		};
		this.handleChange = this.handleChange.bind(this);
		sessionStorage.clear();
 	}
	componentDidMount() {
		if(localStorage.getItem('fin_year') == null){
			var cf = '';
			var year = new Date().getFullYear();
			if(new Date().getMonth() >= 3)
				cf = year+'-'+(year+1);
			else
				cf = (year-1)+'-'+year;
			localStorage.setItem('fin_year', cf);
		}
		else{
			cf = localStorage.getItem('fin_year');
		}
		this.setState({currentFinYear:  cf});
			
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ fin_year: cf })
		};
		this.fetchData(requestOptions);
		
	  }  
	fetchData(requestOptions){
		fetch(MENU_HEADER_URL,requestOptions)
			.then(res => res.json())
			.then(
				(result) => {
					this.setState({
						isLoaded: true,
						items: result.DATA,
						finYearArr: result.FINYEARLIST,
						// currentFinYear: result.CURRENTFINYEAR
					});
					if(result.ERROR){
						//alert(result.ERROR);
						this.setState({
							isLoaded: true,
							error : result.ERROR
						});
	
					}
				},
				// Note: it's important to handle errors here
				// instead of a catch() block so that we don't swallow
				// exceptions from actual bugs in components.
				(error) => {
					this.setState({
						isLoaded: true,
						error : error
					});
				}
			)
			this.render();
	}
	handleChange(event){
		localStorage.setItem('fin_year', event.target.value);

		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ fin_year: event.target.value })
		};
		this.fetchData(requestOptions);
		this.setState({currentFinYear:  event.target.value});
	}
	
	render() {  
		const { error, isLoaded, items, finYearArr } = this.state;
		let count = 0;
		if(items != null)
			count = (items.length % 2);
		if (error) {
		return (<div>
			<NavbarComponent/>
			<div className="App-common main">
				<Container className="centered">
					<Row>
						<Col className="col-1"></Col>
						<Col>Error <FaExclamationTriangle/> 
							<h6>
								An error has occured. Contact Administrator. <br/>
								Refresh page to retry.</h6></Col>
					</Row>
				</Container>
			</div>
			<FooterComponent/>
		</div>);
		} 
		else if (!isLoaded) {
			return(<div class="simple-shape two"></div>)
		} 
		else if (items.length === 0) {
			return (<div>
				<NavbarComponent/>
				<div className="App-common main">
					<Container className="centered">
						<Row>
							<Col className="col-1"></Col>
							<Col>Loading <div className='loader'></div>
								<h6>
									No data available
								</h6>
							</Col>
						</Row>
					</Container>
				</div>
				<FooterComponent/>
			</div>);
		} 
		else {
			return (
				<div>
					<NavbarComponent/>
					<nav className="sticky">
						<Container>
							<Row className="text-center">
								<Col className="col-md-2 col-sm-4 col-lg-2">
									<Form.Label> Financial Year</Form.Label>
								</Col>
								<Col className="col-md-2 col-sm-4 col-lg-2">
									<Form.Select aria-label="Select Financial Year" size="sm" onChange={this.handleChange} value={this.state.currentFinYear}>
										<option> --- SELECT  --- </option>
										{finYearArr.map(elem =>(
											<option value={`${elem.fin_year}`} key={elem.fin_year} >{elem.fin_year}</option>
										) )}
									</Form.Select>
								</Col>
							</Row>
							</Container>
						</nav>
						<div className="App-common main"> 
							<Container>
								<Row>
								{items.map(item => (
									<Col className="col-sm-4 col-md-3 col-lg-2 mt-2" key={item.name+item.id}>
										<Link to={`${item.link}`} >
										<Card className='menu-card'>
											<Card.Body>
												<Card.Title>
													{(item.name.length < 45 )?
													<h1 className="gold largeIcon"><img src={`../images/${item.icon_img}`} width="60" alt='icon'/></h1>
													:<></>}<Row>
														<Col>
															{item.name}
														</Col>
														{(item.menu_type === 'pdf')?
														(<Col className='col-1'>
															<img src="../images/pdf-icon.png" width="15" alt='icon'/>
														</Col>):(<Col className='col-1'>
															<FaArrowCircleRight/>
														</Col>)
														}
													</Row>
												</Card.Title>
											</Card.Body>
										</Card>
										</Link>						
									</Col>
								))}
								{(count === 1)?(
									<Col></Col>
								):(<div></div>)}
								</Row>
							</Container> 
					</div>
					<FooterComponent/>
				</div>
			)
		} 
  	}  
}  
export default MainComponent